/* glightbox
========================================================= */
/* global GLightbox */
export function initGlightbox() {
  const links = document.querySelectorAll(':is(.p-content__body, .p-gallery__archive-list) a:is([href$=".jpg"], [href$=".jpeg"], [href$=".png"], [href$=".webp"])');

  if (!links.length || typeof GLightbox === 'undefined') return;

  links.forEach((link) => {
    if (!link.classList.contains('glightbox')) {
      link.classList.add('glightbox');
    }
  });

  GLightbox({
    selector: '.glightbox',
  });
}
